import { MutationTree } from 'vuex';
import { ManagementServicesState } from './types';

export const mutations: MutationTree<ManagementServicesState> = {
    setManagementServices: (state, data) => {
        state.managementServices = data;
    },
    setManagementServicesItem: (state, data) => {
        state.managementServicesItem = data;
    }
};
